import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const GroupServiceConfig = {
  name: "Group",
  annotations: []
} as ServiceConfig;